import {
  IProviderOption,
  Provider,
} from "@/components/excel/schema/definiens/provider";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/label/type/date";
import {
  HourOption,
  MinuteOption,
  SecondOption,
} from "@/components/excel/schema/label/type/time";

function provideDateTime(option: IProviderOption, suffix: string) {
  const names: string[] = [];
  option.value.forEach((item: number | number[]) => {
    if (Array.isArray(item)) {
      if (option.showPrefix) {
        const name = item.join(option.separator);
        names.push(name);
      } else if (option.showSuffix) {
        names.push(item[item.length - 1] + suffix);
      } else {
        names.push(item[item.length - 1].toString());
      }
    } else if (option.showSuffix) {
      names.push(item + suffix);
    } else {
      names.push(item.toString());
    }
  });
  return names;
}
export const DateTimeNameProvider: { [key: number]: Provider } = {
  [YearOption.value]: function (option: IProviderOption) {
    return provideDateTime(option, "年");
  },
  [MonthOption.value]: function (option: IProviderOption) {
    const o =
      option.separator === undefined ? { ...option, separator: "-" } : option;
    return provideDateTime(o, "月");
  },
  [DayOption.value]: function (option: IProviderOption) {
    const o =
      option.separator === undefined ? { ...option, separator: "-" } : option;
    return provideDateTime(o, "日");
  },
  [HourOption.value]: function (option: IProviderOption) {
    return provideDateTime(option, "时");
  },
  [MinuteOption.value]: function (option: IProviderOption) {
    const o =
      option.separator === undefined ? { ...option, separator: ":" } : option;
    return provideDateTime(o, "分");
  },
  [SecondOption.value]: function (option: IProviderOption) {
    const o =
      option.separator === undefined ? { ...option, separator: ":" } : option;
    return provideDateTime(o, "秒");
  },
};
